import { ethereumNetworkInfo } from '@tokenyico/design-system';
import { providers, chainList as chains } from 'index';
import { ethers } from 'ethers';

export const getProvidersForChain = (_chain) => {
  let chainId = _chain;
  if (typeof chainId === 'string') {
    // string chain, resolve with design-system ethereum info
    chainId = ethereumNetworkInfo.get(chainId).chainId;
  }

  // find chain from wagmi config
  const chain = chains.find((chain) => chain.id === chainId);

  // find urls from wagmi providers
  const rpcUrls = providers
    .map((provider) => provider(chain)?.rpcUrls?.http?.[0])
    .filter((url) => url); // filter out nulls

  // transform into ethers providers
  const rpcProviders = rpcUrls.map((url) => new ethers.providers.JsonRpcProvider(url));

  // https://docs.ethers.org/v5/api/providers/other/#FallbackProvider
  return new ethers.providers.FallbackProvider(rpcProviders, 1);
};
